import { Grid } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import HdFormikDropDown from '../../../../../form/formik/components/dropdown/HdFormikDropDown';
import HdFormikPasswordField from '../../../../../form/formik/components/password-field/HdFormikPasswordField';
import HdFormikTextField from '../../../../../form/formik/components/text-field/HdFormikTextField';
import HdFormControl from '../../../../../form/components/form-control/HdFormControl';
import { TARGET_CLEVERTAP_REGIONS } from './constants';

export default function CleverTap({ isEditing }: { isEditing: boolean }) {
  const formikProps = useFormikContext<{
    region: object | null;
    regionValue: string;
  }>();

  const onChangeRegionEventHandler = selected => {
    if (selected) {
      formikProps.setValues({
        ...formikProps.values,
        region: selected,
        regionValue: selected.value
      });
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
          <HdFormControl>
            <Field
              name='projectId'
              label='Project ID'
              required
              helperText='The ID of your CleverTap project.'
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={6} md={6}>
          <HdFormControl>
            <Field
              name='passcode'
              label='Project Passcode'
              masked={isEditing}
              required
              helperText='The passcode of your CleverTap project.'
              component={HdFormikPasswordField}
            />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
          <HdFormControl>
            <Field
              name='region'
              options={TARGET_CLEVERTAP_REGIONS}
              required
              label='Region'
              helperText='The region of your CleverTap account.'
              component={HdFormikDropDown}
              onChangeEventHandler={onChangeRegionEventHandler}
            />
          </HdFormControl>
        </Grid>
      </Grid>
    </>
  );
}
